import { useCallback } from 'react';
import { Node } from 'reactflow';

import { POSITIONS_STORAGE_KEY_PREFIX } from '../constants';
import type { NodePositionMap } from '../types';

export default function useNodePositions(appId: string, scenarioId: string) {
  const storageKey = `${POSITIONS_STORAGE_KEY_PREFIX}-${appId}-${scenarioId}`;

  const savePositions = useCallback(
    (nodes: Node[]) => {
      const positions: NodePositionMap = {};
      nodes.forEach((node) => {
        // Only save top-level nodes (skip quest child nodes)
        if (!node.parentNode) {
          positions[node.id] = node.position;
        }
      });
      try {
        localStorage.setItem(storageKey, JSON.stringify(positions));
      } catch {
        // localStorage full — ignore silently
      }
    },
    [storageKey]
  );

  const loadPositions = useCallback((): NodePositionMap | null => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  }, [storageKey]);

  const clearPositions = useCallback(() => {
    localStorage.removeItem(storageKey);
  }, [storageKey]);

  return { savePositions, loadPositions, clearPositions };
}
